import { CustomDatePicker } from 'components/shared/CustomDatePicker';
import moment from 'moment';
import React, { useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Badge, Card, CardBody, Col, Row } from 'reactstrap'
import { error } from 'toastr';

type PropsTypes = {
    statusList: Array<any>,
    onClick(item: any): void;
    statusName?: any,
}

const StatusFilters = ({ statusList, onClick, statusName }: PropsTypes) => {
    const [menu, setMenu] = useState(false);

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
                {statusName && <Badge className='bg-dark'>{statusName} <i className='fa fa-times cursor-pointer' onClick={() => onClick(null)}></i></Badge>}
                <DropdownToggle className="btn" id="page-header-user-dropdown" tag="button">
                    <i className='mdi mdi-filter-menu-outline font-size-22 cursor-pointer me-2 text-primary'></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    {statusList.map((list, idx) => (
                        <DropdownItem tag="span" key={idx} onClick={() => onClick(list.Id)} className={`${list.Name == statusName && 'bg-light fw-semibold'}`}>
                            <i className="bx bx-filter font-size-14 align-middle me-3" />
                            <span className='fs-6 cursor-pointer'>{list.Name}</span>
                        </DropdownItem>
                    ))}
                    <DropdownItem tag="span" onClick={() => onClick(null)}>
                        <i className="bx bx-reset font-size-14 align-middle me-3 text-danger" />
                        <span className='fs-6 cursor-pointer text-danger' >Reset</span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

export default StatusFilters